import {newInitializeSelectRentObjectScreen, newSelectRentObject} from "../../shared/actions.js";

export const initialize = newInitializeSelectRentObjectScreen({reservationPath: "B2B", isLtr: false});

export const selectRentObject = newSelectRentObject({reservationPath: "B2B", isLtr: false});
